interface EAVendorBadgeProps {
  vendor: string
  size?: 'sm' | 'md'
}

const vendorColors: Record<string, { bg: string; text: string; border: string }> = {
  Arista: {
    bg: 'rgba(37, 99, 235, 0.15)',
    text: '#60a5fa',
    border: 'rgba(37, 99, 235, 0.3)',
  },
  PaloAlto: {
    bg: 'rgba(220, 38, 38, 0.15)',
    text: '#f87171',
    border: 'rgba(220, 38, 38, 0.3)',
  },
  Nutanix: {
    bg: 'rgba(5, 150, 105, 0.15)',
    text: '#34d399',
    border: 'rgba(5, 150, 105, 0.3)',
  },
  Azure: {
    bg: 'rgba(2, 132, 199, 0.15)',
    text: '#38bdf8',
    border: 'rgba(2, 132, 199, 0.3)',
  },
  Cisco: {
    bg: 'rgba(124, 58, 237, 0.15)',
    text: '#a78bfa',
    border: 'rgba(124, 58, 237, 0.3)',
  },
}

const defaultColors = {
  bg: 'rgba(100, 116, 139, 0.15)',
  text: '#94a3b8',
  border: 'rgba(100, 116, 139, 0.3)',
}

export default function EAVendorBadge({ vendor, size = 'sm' }: EAVendorBadgeProps) {
  const colors = vendorColors[vendor] || defaultColors

  const sizeClasses = size === 'md'
    ? 'px-2.5 py-1 text-xs'
    : 'px-2 py-0.5 text-xs'

  return (
    <span
      className={`inline-flex items-center rounded-md font-medium ${sizeClasses}`}
      style={{
        backgroundColor: colors.bg,
        color: colors.text,
        border: `1px solid ${colors.border}`,
      }}
    >
      {vendor}
    </span>
  )
}
